import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import {
  PipelineGenericActions,
  PipelineGenericStoreSelectors,
  PipelineGenericStoreReducer,
} from "./index";

@Injectable()
export class PipelineGenericFacade {
  constructor(
    private store: Store<PipelineGenericStoreReducer.GenericPartialState>,
  ) {}

  pipelineGenericRecord$ = this.store.select(
    PipelineGenericStoreSelectors.getSelected,
  );

  getselected() {
    return this.store.select(PipelineGenericStoreSelectors.getSelected);
  }

  isLoadingPipelineGeneric(modelType: string) {
    return this.store.select(PipelineGenericStoreSelectors.loadingGeneric(modelType));
  }

  isLoadingPipelineGenericById(modelType: string, id: string) {
    this.store.dispatch(
      PipelineGenericActions.loadByIdGeneric(modelType)({ modelType, id }),
    );
    return this.store.select(PipelineGenericStoreSelectors.loadingGeneric(modelType));
  }

  isLoadingPipelineGenericWithoutId(modelType: string) {
    this.store.dispatch(
      PipelineGenericActions.loadGenericWithoutId(modelType)({ modelType }),
    );
    return this.store.select(PipelineGenericStoreSelectors.loadingGeneric(modelType));
  }

  loadGateway(modelType: string, id: string) {
    this.store.dispatch(
      PipelineGenericActions.loadGeneric(modelType)({ modelType, id }),
    );
    return this.store.select(
      PipelineGenericStoreSelectors.getAllGeneric(modelType),
    );
  }

  loadGatewayById(modelType: string) {
    return this.store.select(
      PipelineGenericStoreSelectors.getAllGeneric(modelType),
    );
  }

  loadGatewayWithoutId(modelType: string) {
    return this.store.select(
      PipelineGenericStoreSelectors.getAllGeneric(modelType),
    );
  }

  loadGatewayClear(modelType: string) {
    this.store.dispatch(PipelineGenericActions.loadGenericClearState(modelType)({ modelType }));
    return this.store.select(
      PipelineGenericStoreSelectors.getAllGeneric(modelType),
    );
  }

  add(modelType: string, dataToAdd: any[]) {
    this.store.dispatch(
      PipelineGenericActions.addGeneric(modelType)({ dataToAdd, modelType }),
    );
  }

  update(modelType: string, dataToAdd: any[], deletedData: any[]) {
    // console.log("Reaching Update Facade ", dataToAdd);
    this.store.dispatch(
      PipelineGenericActions.updateGeneric(modelType)(
        { dataToAdd, deletedData, modelType },
      ),
    );
  }

  remove(modelType: string, ids: string[]) {
    this.store.dispatch(
      PipelineGenericActions.removeGeneric(modelType)({ ids, modelType }),
    );


  }
}
